import styled from "styled-components/native";

import { colors } from "@/theme/colors";

export const Container = styled.View`
  flex: 1;
  margin-top: 70px;
  margin-bottom: 30px;
  justify-content: center;
`;

export const ViewGrausMadureza = styled.View`
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
  margin-top: -52px;
`;

export const ViewTextsGrauMadureza = styled.View`
  height: 20px;
  margin-bottom: 10px;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
`;

type ComponentProps = {
  isGreen: boolean;
  isNormal: boolean;
  isMature: boolean;
};

export const TextGrauMadureza = styled.Text<ComponentProps>`
  font-weight: ${(props) =>
    !props.isGreen && !props.isNormal && !props.isMature ? "normal" : "bold"};
  font-size: 18px;

  margin-left: ${(props) => (props.isGreen || props.isMature ? 0 : 10)}px;

  color: ${(props) =>
    props.isGreen
      ? "#52BF1B"
      : props.isNormal
      ? "#ABD80D"
      : props.isMature
      ? "#ff8c00"
      : colors.text[600]};
`;

export const ViewButtonsGrauMadureza = styled.View`
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
`;

export const ButtonGrauMadureza = styled.TouchableOpacity<ComponentProps>`
  height: 30px;
  width: 30px;
  border-radius: 20px;
  align-items: center;
  justify-content: center;
  margin-top: 5px;

  background-color: ${(props) =>
    props.isGreen
      ? "#52BF1B"
      : props.isNormal
      ? "#ABD80D"
      : props.isMature
      ? "#ff8c00"
      : "#C3CAD9"};
`;

export const BolaMenor = styled.View<ComponentProps>`
  height: 20px;
  width: 20px;
  border-radius: 15px;
  background-color: ${(props) =>
    props.isGreen ? "#52BF1B" : props.isNormal ? "#ABD80D" : props.isMature ? "#ff8c00" : "white"};
`;
